import script from "./BlogHeaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogHeaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./BlogHeaderComponent.vue?vue&type=style&index=0&id=e3c39c22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3c39c22"]])

export default __exports__